"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendSmsActionLabel = void 0;
const lib_palette_1 = require("@opsbase/lib-palette");
const react_1 = __importDefault(require("react"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
function SendSmsActionLabel(props) {
    const { action } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    const sendTo = config === null || config === void 0 ? void 0 : config.sendTo.map(s => s.split('.').join(''));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ' ' + lib_i18n_1.default.t('to') + ' ',
        react_1.default.createElement("span", { style: { color: lib_palette_1.Palette.secondary.dark, fontStyle: 'italic' } }, sendTo === null || sendTo === void 0 ? void 0 : sendTo.join(','))));
}
exports.SendSmsActionLabel = SendSmsActionLabel;
exports.default = SendSmsActionLabel;
